<style type="text/css">
  .dropzone .dz-progress{
    display: none !important;
  }
  .m-body .m-content {
    padding-bottom: 0;
  }

  #messages_container {
    overflow-x: hidden;
    min-height: -webkit-fill-available;
    scroll-behavior: smooth;
    -webkit-transition: all 1s ease-in-out;
    transition: all 1s ease-in-out;
  }

.support_name{
  font-size: 14px;
  font-weight: bold;
}

  .support_message {
    margin-top: 15px;
    width: 60% !important;
    display: flex;
    flex-direction: column;
    justify-content: end;
  }
  .support_message.from_user{
    align-items: flex-start;
  } 

  .support_message.from_admin {
    margin-left: 40%;
    align-items: flex-end;
  }

  .support_message.from_user span.message_time {
    display: block;
    text-align: right;
     margin-right:20px;
  }

  .support_message.from_admin span.message_time {
    display: block;
    text-align: left;
     margin-left: 10px;
  }

  .support_message .user_logo {
    float: left;
    overflow: hidden;
    border-radius: 50%;
    background: white;
  }

  .support_message.from_admin .user_logo {
    float: right;
    margin-right: 15px;
  }

  .support_message .user_logo img {
    width: 50px;
    height: 50px;
  }

  .support_message .message_content {
    position: relative;
    width: calc(100% - 75px);
    display: inline-block;
    margin-left: 25px;
    background: white;
    padding: 10px;
    border-radius: 0px 10px 10px 10px;
  }

  .support_message.from_admin .message_content {
    width: calc(100% - 75px);
    border: 0;
    border-radius: 10px 0px 10px 10px;
    float: none;
    margin: 0;
    margin-right: 70px;
    background: #48a6a6;
    color: white;
  }

  .support_message .message_content:before {
    content: "";
    position: absolute;
    height: 0;
    width: 0;
    right: 100%;
    top: 0;
    border: 15px solid transparent;
  }

  .support_message.from_user .message_content:before {
    border-right: 0 solid white;
    border-top: 20px solid white;
  }

  .support_message.from_admin .message_content:before {
    right: 0;
    left: 100%;
    border-left: 0 solid #22b9ff;
    border-top: 20px solid #22b9ff;
  }

  .support_message .message_content ul {
    margin: 0;
    padding: 0;
  }
.support_message .message_content ul li.img-list {
    width: 25%;
    float: left;
    text-align: center;
    display: inline-block;
    margin-bottom: 4px;
    margin-left: 0;
  }
  .support_message .message_content ul li {
    width: 100%;
    display: list-item;
    margin-bottom: 4px;
    margin-left:26px;
    text-align: left;
  }
  .support_message .message_content td ul li {
  width: 100%;
  text-align: left !important;
  display: block;
}

  .support_message .message_content img,
  .support_message .message_content iframe {
    
  }

  .support_message .message_content ul li a {
    text-decoration: none;
    color: #0091d5;
    font-weight: 500;
  }

  .support_message.from_admin .message_content ul li a {
    color: white;
  }

  .support_message .message_content ul li a .attachment_icon {
    padding: 10px;
  }

  .support_message .message_content ul li a .attachment_icon i {
    font-size: 66px;
    color: #0091d5;
  }

  .support_message.from_admin .message_content ul li a .attachment_icon i {
    color: white;
  }

  .support_message .message_content ul li a span {
    width: 80px;
    overflow: hidden;
    display: inline-block;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 12px;
    margin-left: 5px;
  }

  .support_message .message_content a:hover {
    color: #2739c1;
  }

  .support_message.from_admin .message_content a {
    color: black;
  }

  /* width */
  #messages_container::-webkit-scrollbar {
    width: 5px;
  }

  /* Track */
  #messages_container::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  /* Handle */
  #messages_container::-webkit-scrollbar-thumb {
    background: #22b9ff;
  }

  /* Handle on hover */
  #messages_container::-webkit-scrollbar-thumb:hover {
    background: #43b3e7;
  }

  textarea {
    resize: vertical;
  }

  /* .dropzone {
    border: 2px solid #22b9ff;
  } */

  select.form-control {
    padding: 0;
    padding-left: 10px;
  }
  input {
    position: relative;
  }

  input[type="date"]::-webkit-calendar-picker-indicator {
      background-position: right;
      background-size: auto;
      cursor: pointer;
      position: absolute;
      bottom: 0;
      left: 0;
      top: 18% !important;
      right: 2%;
      width: auto;
  }
  .style-label label {
    color: rgb(72, 166, 166) !important;
  }
  .support_message.from_user .message_content {
    margin-left: 55px;
    background: #d7d7d7; 
    color: #333;
  }
  .support_message.from_user .message_content:before {
    content: "";
    position: absolute;
    height: 0;
    width: 0;
    right: 100%;
    top: 0;
    border: 15px solid transparent;
  }
  .support_message.from_user .message_content:before {
    left: -14px !important;
    right: auto !important;
    border-right: 0 solid #22b9ff !important;
    border-top: 20px solid #22b9ff !important;
  }
  @media (min-width: 320px) and (max-width:680px){
    .support_message .message_content ul li a span {
      width: 51px !important;
    }
    .support_message{
      width: 100% !important;
      font-size: 0.9rem !important;
    }
    .support_message.from_admin {
      margin-left: 5% !important;
    }
    .delivery_date{
      border-left: 0px !important;
    }
    .saveBtn{
      text-align: center !important;
    }
    .support_message.from_user span.message_time{
      margin-right: 5% !important;
    }
    #dropAttach{
      padding: 6% 14% !important;
    }
    .support_message:not(.from_admin) .message_content {
      width: calc(100% - 90px) !important;
      background: #d7d7d7 !important;
    }

    .support_message.from_user .message_content:before {
      /* border-right: 0 solid white; */
      /* border-top: 20px solid white; */
      /* left: 0; */
      right: 100%;
      border-right: 0 solid #22b9ff;
      border-top: 20px solid #22b9ff;
    }
    .tox.tox-tinymce.tox-platform-touch{
      height: 250px !important;
    }
    .message_content >.message_para p{
      margin-bottom: 0.2rem !important;
    }
 }
 .support_message .message_content table table{
  max-width: 95%;
  width:auto !important;
 }
 .support_message .message_content table table div img{
  width: 250px !important;
  height: 74px !important;
 }
 .support_message .message_content table table div a img{
  width: 24px !important;
  height: 24px !important;
 }
 .support_message .message_content table>tbody>tr>td>table>tbody>tr>td>img{
  width: 24px !important;
  height: 24px !important;
 }
 .support_message .message_content table>tbody>tr>td>table>tbody>tr>td>table>tbody{
  display: block;
 }
 .message_para img{
    height: auto !important;
    max-width: 390px !important;
}
.message_para div {
    margin-left: 2px !important;
} 
.support_message.from_user .commentWrapper{
  width: calc(100% - 75px);
  margin: 10px 55px;
}
.support_message.from_admin .commentWrapper{
  width: calc(100% - 75px);
  margin: 10px 70px 10px 0px;
}
.commentWrapper .totalComment{
  margin-bottom:10px;
  display: flex;
  justify-content: space-between;
}
.commentWrapper .totalComment button:last-child{
  margin-left: auto;
}
.commentWrapper .commentNo{
  padding: 0 4px;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  text-align: left;
  color: #48A6A6;
} 
.commentWrapper .repliedWrapper{
  width: calc(100% - 20px);
  margin: 0 0 0 auto;
  max-height: 0;
  overflow: hidden;
  transition: all 1s ease-in-out;scroll-behavior: smooth;
}
.commentWrapper .addNoteBox{
  max-height: 0;
  overflow: hidden;
  transition: all 1s ease-in-out;
  position: relative;
}
.commentWrapper .showAddNoteBox{
  max-height: max-content;
}
.commentWrapper .repliedWrapper .allRepliled{
  display: flex;
  flex-direction: column;
  row-gap: 12px;
  margin: 12px 0;

}
.commentWrapper .repliedWrapper .repliedSection{
  border-radius: 16px;
  padding: 16px;
  background: #48A6A60A;
} 
.commentWrapper .repliedWrapper .repliedSection .repliedMessage{
  font-family: Poppins;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  text-align: left;
  margin: 0;
}

.commentWrapper .repliedWrapper.showReplies{
  max-height: 400px;
  overflow: auto;
}
 /* width */
.repliedWrapper.showReplies::-webkit-scrollbar {
  width: 5px;
}

/* Track */
.repliedWrapper.showReplies::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
.repliedWrapper.showReplies::-webkit-scrollbar-thumb {
  background: #22b9ff;
}

/* Handle on hover */
.repliedWrapper.showReplies::-webkit-scrollbar-thumb:hover {
  background: #43b3e7;
}
.totalComment .imgGray{
  filter: brightness(0) saturate(100%) invert(21%) sepia(0%) saturate(2%) hue-rotate(217deg) brightness(93%) contrast(89%);
}
.totalComment .emptyComment{
  color: #3a3a3a;
}
.support_message.from_user{
  position: relative;
}
.commentInfo{
  display: none;
  max-width: 200px;
  height: auto;
  border-radius: 8px;
  padding: 12px;
  position: absolute;
  bottom: 33px;
  right: -60px;
  background: #fff;
  z-index: 100;
  box-shadow: rgba(0, 0, 0, 0.19) 0px 10px 20px, rgba(0, 0, 0, 0.23) 0px 6px 6px;}
.commentButton:hover ~ .commentInfo{
  display: block;
}
.add-noteHeading{
  font-size: 12px;
  margin: 0;
}
  .message-header {
    display: block;
    justify-content: space-between;
    align-items: center;
  }

  .sender-name {
    font-weight: bold;
  }

  .message-time {
    font-size: 0.85em;
    color: #888;
  }

  .message-text {
    margin: 10px 0;
  }
  .collapse-btn {
    //background-color: #007bff;
    //color: white;
    border: none;
    padding: 5px 10px;
    cursor: pointer;
    border-radius: 5px;
    margin-top: 10px;
  }


  .reply-section {
    margin-top: 10px;
    padding-left: 20px;
    border-left: 2px solid #007bff;
  }

  .message-meta {
    display: flex;
    align-items: center;
  }
  .badge {
    position: absolute;
    top: -5px;
    left: -5px;
    background-color: #737791;
    color: #fff;
    padding: 2px 5px;
    border-radius: 50%;
    font-size: 10px;
  }
  .commentButton {
    position: relative;
  }
</style>
<template>
  <div class="new_ticket" ref="scrollContainer">
    <div id="ticket_responsive" style="display:none;">
            <div id="ticket_inner" style="background-color: rgb(47 109 158); height: 46px; padding: 2% 6%;">
                <button class="float-left" style="margin: 0.5% 0% 0% 0%;" @click="backButton">
                  <svg width="26" height="26" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8.00135 9.99865C8.00109 9.8652 8.04757 9.73588 8.13271 9.63312L10.9884 6.20632C11.0853 6.08969 11.2246 6.01634 11.3757 6.00242C11.5267 5.98849 11.677 6.03513 11.7937 6.13208C11.9103 6.22902 11.9837 6.36833 11.9976 6.51935C12.0115 6.67037 11.9649 6.82074 11.8679 6.93737L9.30925 9.99865L11.7765 13.0599C11.824 13.1183 11.8594 13.1856 11.8808 13.2577C11.9022 13.3299 11.9091 13.4055 11.9011 13.4804C11.8932 13.5552 11.8705 13.6277 11.8344 13.6938C11.7983 13.7598 11.7495 13.8181 11.6909 13.8652C11.6321 13.9175 11.5633 13.9571 11.4885 13.9816C11.4138 14.006 11.3348 14.0148 11.2565 14.0073C11.1782 13.9997 11.1023 13.9762 11.0336 13.938C10.9648 13.8998 10.9047 13.8478 10.857 13.7853L8.09844 10.3585C8.02676 10.2528 7.99257 10.1261 8.00135 9.99865Z" fill="white"/>
                    <rect x="19.5" y="0.5" width="19" height="19" rx="3.5" transform="rotate(90 19.5 0.5)" stroke="white"/>
                  </svg>
                </button>
        
                <div class="float-left"  id="support_heading">
                    <h5  style="color:white;    margin-top: 0.2rem !important;  font-family:Mulish,sans-serif;">Support</h5>
                </div>
              
            </div>
        

        </div>
        
    <form class="forms-sample" style="margin-bottom: 0; border-bottom: 1px solid rgba(0, 0, 0, 0.1)">
      <h6 class="sub-title mb-3 font-weight-bold color-default" style="border: 0; margin: 0 !important; padding: 0">
        {{ formHeader }}
      </h6>
    </form>
    <form class="forms-sample" :key="this.$route.params.ticket" ref="formContainer" style="margin-top: 0">
      <div class="form-group row">
        <div id="messages_container" class="col-md-7" ref="chatContainer">
          <div class="row" v-for="(tm, index) in ticket.messages" :key="index">

            <div v-bind:class="{
                support_message: 1,
                from_admin: tm.sent_by_admin == 1,
                from_user: tm.sent_by_admin == 0,
              }">

              <div>
                <div v-if="tm.sent_by_admin == 1" class="d-flex align-items-center">
                  <span class="mr-2" style="font-weight: bold; font-size: 14px">{{ tm.reply_user ? tm.reply_user.first_name + ' ' +  tm.reply_user.last_name : 'Support' }}</span>

                  <div class="user_logo">
                    <img src="/blank-profile-picture.png" alt="Logo" />
                  </div>
                </div>

                <div v-else class="d-flex justify-content-start align-items-start ">
                  <div class="user_logo">
                    <img :src="amazon_profile_url" alt="Logo" />
                  </div>
                  <div class="ml-3">
                    <P class="m-0" style="font-weight: bold; font-size: 14px;cursor: pointer"><a @click="quickView" :data-id="ticket.organization_id" :data-user="ticket.user_id || ''">{{ ticket.organization_name }}</a></P>
                    <P class="m-0">{{ ticket.user_name }}<span v-if="ticket.user_email" class="m-sm-1">({{ ticket.user_email }})</span></P>
                  </div>

                </div>
              </div>
              <div class="new-replay-box" style="width: 100%;">
                  <span class="message_time">{{
                tm.created_at | formatDateTime 
                }} </span>
              <div class="message_content">
                <p class="message_para" v-html="tm.message" style=""></p>

                <div v-if="tm.attachments.length">
                  <hr />
                  <ul>
                    <li class="img-list" v-for="(tma, index) in tm.attachments" :key="index">

                      <a :href="tma.is_imap == 1 ? imapUrl+tma.path :  amazonUrl+tma.path " target="_blank" :title="tma.name">
                        <font-awesome-icon :icon="['fas', 'file-image']" size="3x" v-if="
                            supportedImageFormats.includes(
                              tma.name.substr(tma.name.lastIndexOf('.'))
                            )
                          " />
                        <font-awesome-icon :icon="['fas', 'file-word']" size="3x" v-else-if="
                            supportedDocumentFormats.includes(
                              tma.name.substr(tma.name.lastIndexOf('.'))
                            )
                          " />
                        <font-awesome-icon :icon="['fas', 'file-video']" size="3x" v-else-if="
                            supportedVideoFormats.includes(
                              tma.name.substr(tma.name.lastIndexOf('.'))
                            )
                          " />
                        <font-awesome-icon :icon="['fas', 'file-audio']" size="3x" v-else-if="
                            supportedAudioFormats.includes(
                              tma.name.substr(tma.name.lastIndexOf('.'))
                            )
                          " />
                        <font-awesome-icon :icon="['fas', 'tag']" size="3x" v-else />
                        <span>{{ tma.name }}</span>
                      </a>
                    </li>
                  </ul>
                </div>
                <div class="commentInfo">
                  <div class="commentInfoWrapper">
                    <div>
                      <h6 class="add-noteHeading">Add Note</h6>
                    </div>
                  </div>
                </div>
              </div>
              </div>
              <div class="commentWrapper">
                <div class="totalComment">
                  <button v-if="(tm.comments.length + (notesCount[tm.id] || 0)) > 0" type="button" @click="showReply(index,tm.id)">
                    <img :src="commentIcon" alt="comment-icon"/>
                    <span class="commentNo">
                      {{ tm.comments.length + (notesCount[tm.id] || 0) }} {{ tm.comments.length + (notesCount[tm.id] || 0) === 1 ? 'note' : 'notes'  }}
                    </span>
                  </button>
                  <button type="button" @click="showAddNote(index, tm.id)">
                    <span class="commentNo">
                          Add Note
                    </span>
                  </button>
                </div>
                <div class="repliedWrapper" :data-id="tm.id" :class="{ showReplies: !isReplyVisible(index, tm.id),'': isReplyVisible(index, tm.id),['showReplies-' + tm.id]: !isReplyVisible(index, tm.id) }" >
                  <div class="allRepliled" :data-id="tm.id">
                    <div class="repliedSection" v-for="(note) in tm.comments" :key="note.id">
                      <p class="repliedMessage" v-html="note.comment">
                      </p>
                    </div>

                    <div class="repliedSection" v-for="(comment, index) in comments[tm.id] || []" :key="index">
                      <p class="repliedMessage" v-html="`${comment}`"></p>
                    </div>

                  </div>
                  <div class="addNoteBox"  :class="{ showAddNoteBox: showAddNoteBox === index }">
                    <support_comment :form-data="formData" :height="200" :editorId="tm.id"></support_comment>
                  </div>
                </div>
              </div>
              </div>


          </div>
          <div id="messages_container_end"></div>

        </div>
        <div class="col-md-5 delivery_date" style="border-left: 1px solid rgba(0, 0, 0, 0.1)">

          <!-- title input -->
          <div class="col-md-12 style-label" v-if="ticket.status != 10">
            <label class="label-form" for="message">Message:</label>
            <tiny-mce-editor :vModelName.sync="ticketForm.message" ></tiny-mce-editor>
            <!-- <textarea id="message" v-model="ticketForm.message" placeholder="Message" class="form-control"></textarea> -->
          </div>
          <br />
          <!-- caption input -->
          <div class="col-md-12" v-if="ticket.status != 10">
            <vue-dropzone ref="myVueDropzone" id="dropAttach" :options="dropzoneOptions"></vue-dropzone>
          </div>
        </div>
      </div>
      <div class="text-right saveBtn" v-if="ticket.status != 10">
        <button class="btn btn-default" @click.prevent="save">Submit</button>
      </div>
    </form>
  </div>
</template>

<script>
  import commentIcon from "@/assets/images/comment-support-icon.svg"
  import axios from "axios";
  import "jodit/build/jodit.min.css";
  import JoditVue from "jodit-vue";
  import TinymceEditor from "../../views/partials/tiny_mce_editor";

  import moment from "moment";
  import vue2Dropzone from "vue2-dropzone";
  import "vue2-dropzone/dist/vue2Dropzone.min.css";
  import organizationView from "@/components/organizations/organization-view/customerView";
  import Support_comment from "@/components/support/support_comment.vue";

  Vue.filter("formatDateTime", function (value) {
    if (value) {
      return (
        moment(String(value)).format("MMMM DD, YYYY") +
        " at " +
        moment(String(value)).format("hh:mm:ss A")
      );
    }
  });

  export default {
    components: {
      Support_comment,
      JoditVue,
      vueDropzone: vue2Dropzone,
      "tiny-mce-editor": TinymceEditor,
    },

    data: function () {
       var _this=this;
      var supportedImageFormats = [
        ".jpeg",
        ".jfif",
        ".tiff",
        ".bmp",
        ".jpg",
        ".png",
        ".gif",
      ];
      var supportedDocumentFormats = [
        ".docx",
        ".rtf",
        ".doc",
        ".pdf",
        ".txt",
        ".xls",
        ".xlsx",
      ];
      var supportedVideoFormats = [".mp4", ".avi", ".flv", ".wmv", ".mov"];
      var supportedAudioFormats = [".mp3", ".wav", ".aac"];
      var unique_folder = Math.floor(Math.random() * 90000) + 10000;

      return {

        commentIcon:commentIcon,
        showReplies: true,
        showAddNoteBox: false,
        totalComment:10,
        formHeader: "",
        imapUrl: "",
        user_logo: "",
        ticket: "",
        amazonUrl: "",
        amazon_profile_url: "",
        main_site_url: process.env.VUE_APP_LINENTECH_V3,
        ticketForm: {},
        ticket_delivery_date: "",
        supportedImageFormats: supportedImageFormats,
        supportedDocumentFormats: supportedDocumentFormats,
        supportedVideoFormats: supportedVideoFormats,
        supportedAudioFormats: supportedAudioFormats,
        unique_folder: unique_folder,
        min_date: "",
        buttons: [
          "bold",
          "strikethrough",
          "underline",
          "italic",
          "|",
          "ul",
          "ol",
          "|",
          "image",
          "table",
          "link",
          "|",
          "outdent",
          "indent",
          "|",
          "align",
          "undo",
          "redo",
          "|",
          "hr",
          "symbol",
          "fullsize",
        ],
        config: {
          uploader: {
            insertImageAsBase64URI: true,
          },
        },
        dropzoneOptions: {
          url: process.env.VUE_APP_API_URL+"/api/support/support-files/"+this.$route.params.org_id+"/"+unique_folder, // This is broken link which is not going to upload image.
          maxFiles:5,
          maxFilesize: 10,
         acceptedFiles:
           supportedImageFormats.join(", ") +
           "," +
           supportedDocumentFormats.join(", ") +
           "," +
           supportedVideoFormats.join(", ") +
           "," +
           supportedAudioFormats.join(", "),
         addRemoveLinks: true,
         timeout: 50000,
         autoProcessQueue: false, 
         init: function () {
            var startUpload = document.getElementById("saveButton");
            let fileStuatus = this.files;
            this.dropzoneFiles = this.files;
            localStorage.setItem("files",this.files);
             $(startUpload).on("click", function() {
                 this.ticketForm.attachment = fileStuatus;
             });
         },
         success: function (file, response, xhr) {
           localStorage.setItem("del_attachement",true);
           localStorage.setItem("filename",response.data);
          },
         error: function (file, response, xhr) {
           if (response == "You can't upload files of this type.") {
             var fileRef;
             (fileRef = file.previewElement) != null
               ? fileRef.parentNode.removeChild(file.previewElement)
               : void 0;
                _this.$toast.error(`File Not Supported`);
           }
           else if(response == "You can not upload any more files."){
             var fileRef;
             (fileRef = file.previewElement) != null
               ? fileRef.parentNode.removeChild(file.previewElement)
               : void 0;
               _this.$toast.error(`Maximum Five Files Allowed`);
            // alert("error")
           }
           return false;
         },
         removedfile: function(file) {
            this.remove_file_orgid = localStorage.getItem('ticket_org_id');
            var name = localStorage.getItem("filename");   
            let fileIndex = this.dropzoneFiles.findIndex(p=>p.name == file.name);
            this.dropzoneFiles.splice(fileIndex,1)
            var fileRef;
            return (fileRef = file.previewElement) != null ? fileRef.parentNode.removeChild(file.previewElement) : void 0;
           },
        },
        formData: {},
        messageId: null,
        notesCount: {},
        messagesIndex: {},
        messageReplyId: 0,
        comments: {},
      };
    },

    computed: {
      Note: function () {
        return this.$store.getters['users/leadNotes'];
      },
    },
    created: function () {
      this.reloadSendReply();
    },
    mounted() {
      this.formatDate();
    },
    methods: {
      showReply(index, messageId) {
        if (this.messagesIndex[index] === messageId) {
          this.showAddNoteBox = false;
          this.$set(this.messagesIndex, index, null);
        } else {
          this.$set(this.messagesIndex, index, messageId);
        }
      },
      isReplyVisible(index, messageId) {
        return this.messagesIndex[index] === messageId;
      },

      showAddNote(index,messageId) {
        this.formData = {
          index: index,
          message_id: messageId,
          tkt_id: this.$route.params.ticket
        };
        this.showAddNoteBox = this.showAddNoteBox === index ? null : index;
        this.$set(this.messagesIndex, index, null);
        this.messageId = messageId;
        this.$nextTick(() => {
          this.scrollToBottomRepliedWrapper(messageId);
        });
      },
      scrollToBottom() {
        this.$nextTick(() => {
          const container = this.$refs.chatContainer;
          container.scrollTop = container.scrollHeight;
        });
        window.scrollTo(0, document.body.scrollHeight);
      },
      scrollToBottomRepliedWrapper(index) {
        const repliedWrapper = this.$el.querySelector(`.repliedWrapper[data-id="${index}"]`);
        if (repliedWrapper) {
          repliedWrapper.scrollTop = repliedWrapper.scrollHeight;
        }
      },
      reloadSendReply(){
        if (typeof this.$route.params.ticket === "undefined") {
        return;
      }
      this.ticketForm = {
        id: this.$route.params.ticket,
        org_id: this.$route.params.org_id,
        customer_feedback: false,
        message: "",
        attachment: [],
      };
      // update from
      let loader = this.$loading.show({
        loader: "dots",
        container: this.$refs.formContainer,
      });
      localStorage.setItem('ticket_org_id',this.$route.params.org_id);
      this.formHeader = "";
      this.user_logo = "";
      this.$store
        .dispatch("support/getSuportTicket", [
          this.ticketForm.id,
          this.ticketForm.org_id,
        ])
        .then(() => {
          this.comments = {};
          this.notesCount = {};
          this.ticket = this.$store.getters["support/supportTicket"];
          this.amazonUrl = this.$store.getters["support/amazon_url"];
          this.imapUrl = this.$store.getters["support/imap_url"];
          this.amazon_profile_url = this.$store.getters["support/amazon_profile_url"];
          if(this.amazon_profile_url == null || this.amazon_profile_url == ''){
            this.amazon_profile_url= '/blank-profile-picture.png';
            this.src = '/blank-profile-picture.png';
          }
          let user_logo = this.$store.getters["support/user_logo"];
          this.formHeader = this.ticket.title;
          this.user_logo = user_logo;
          this.$gate.setUnreadTicketsCount();
          if (this.ticket.delivery_date && this.ticket.delivery_time) {
        this.ticket_delivery_date = moment(
            `${this.ticket.delivery_date} ${this.ticket.delivery_time}`
        ).format("YYYY-MM-DDTHH:mm"); // "YYYY-MM-DDTHH:mm" for datetime-local format
         }
          loader.hide();
          this.scrollToBottom();

        })
        .catch((err) => {
          loader.hide();
          this.$toast.error(err);
        });
      },
      backButton(){
            this.$router.go(-1);
        },
      formatDate() {
        var d = new Date(),
          month = "" + (d.getMonth() + 1),
          day = "" + d.getDate(),
          year = d.getFullYear();

        if (month.length < 2) month = "0" + month;
        if (day.length < 2) day = "0" + day;

        this.min_date = [year, month, day].join("-");
      },
      save() {
        if (
          this.ticketForm.message == "" ||
          this.ticketForm.message.length <= 61
        ) {
          this.$toast.warning(`Message can not be empty.`);

          return;
        }
        if(this.$refs.myVueDropzone.getUploadingFiles().length == 0){
          this.sendReply(this.ticketForm);
          // Clear the Dropzone files
          this.$refs.myVueDropzone.removeAllFiles(true); // `true` to also remove the files from the server if applicable
        }else{
          this.$toast.warning(`Files Are Uploading...`);
        }
        localStorage.setItem("del_attachement",false);
      },

      // Send Reply to ticket
      sendReply(ticket) {
        let loader = this.$loading.show({
          loader: "dots",
          container: this.$refs.formContainer,
        });
        ticket["org_id"] = this.ticket.organization_id;
        ticket["user_id"] = this.ticket.user_id;
        ticket["unique_folder"] = this.unique_folder;
        this.ticketForm.attachment = this.$refs.myVueDropzone.getAcceptedFiles();
        this.$store
          .dispatch("support/sendReply", ticket)
          .then((data) => {
            loader.hide();
            // send successful message

            this.$router.push("/support/ticket/"+this.ticketForm.id+"/"+ticket["org_id"]);
            this.reloadSendReply();
             setTimeout(() => {
               this.$toast.success(`Message has been sent successfully`);
               this.scrollToBottom();

            }, 3500);

          })
          .catch((error) => {
            loader.hide();
            let response = error.response;
            // send error message
              this.$router.push("/support/ticket/"+this.ticketForm.id+"/"+ticket["org_id"]);
              this.reloadSendReply();
               setTimeout(() => {
            this.$toast.error(`OOPS! something went wrong`);
            this.scrollToBottom();

            }, 3000);

          
          });
      },


      quickView(event) {
        this.$store.dispatch("modal/orgquickView", {
          action: "create",
          title: "",
          formData: {
            userId: event.target.dataset.user,
            organizationId: event.target.dataset.id,
          },
          component: organizationView,
        });
      },
      getMessageComments(message_id,count,comment){
        // this.$store.dispatch('users/getLeadNotes', ["message_id", message_id]);
        if (comment)
          this.appendComment(comment,message_id);

        if (!this.notesCount[message_id]) {
          this.$set(this.notesCount, message_id, 0);
        }

        this.$set(this.notesCount, message_id, this.notesCount[message_id] + count);
        this.showAddNoteBox = false;
        // this.$set(this.messagesIndex, index, message_id);

      },

      appendComment(comment, message_id) {
        if (!this.comments[message_id]) {
          this.$set(this.comments, message_id, []);
        }
        this.comments[message_id].push(comment);
      },

    },
  };
</script>